import Swiper from "swiper"
import { Navigation, Scrollbar } from "swiper/modules"

/**
 * WORKSセクションの横スライド制御
 *
 * @description PCは2枚・SPは1枚ずつ送る。コントロール（スクロールバー＋矢印）は
 *              VOICEとまったく同じ見た目で、動きはSwiperのScrollbar / Navigationに任せる。
 */

/**
 * スライド1つを初期化する
 * @param {HTMLElement} root - [data-works] を持つ .swiper 要素
 */
const initWorks = (root: HTMLElement): void => {
  const section = root.closest("section")
  const scrollbar = section?.querySelector<HTMLElement>("[data-works-scrollbar]")
  const prev = section?.querySelector<HTMLElement>("[data-works-prev]")
  const next = section?.querySelector<HTMLElement>("[data-works-next]")

  const thumb = scrollbar?.querySelector<HTMLElement>(".works__barThumb")

  if (!scrollbar || !thumb || !prev || !next) return

  /**
   * カード間の余白を求める
   * @returns {number} px
   * @description SwiperがJSでスライドを並べるためCSSのgapは効かない。値はSCSS側に
   *              column-gap（vw）として持たせてあるので、px解決済みの計算値を借りる。
   */
  const gap = (): number => parseFloat(getComputedStyle(root).columnGap) || 0

  /**
   * つまみの幅を求める
   * @returns {number} px
   * @description つまみの幅はVOICEと同じくデザイン固定なのでCSSが持つ。Swiperは
   *              枚数に応じた幅をインラインstyleで上書きしてくるため、いったん消して
   *              CSSの値に戻してから測る。
   */
  const thumbSize = (): number => {
    thumb.style.removeProperty("width")
    return parseFloat(getComputedStyle(thumb).width) || 0
  }

  /**
   * CSSが持つサイズ（カード間の余白・つまみの幅）をSwiperへ渡し直す
   * @param {Swiper} instance - 対象のSwiper
   */
  const applyCssSizes = (instance: Swiper): void => {
    instance.params.spaceBetween = gap()
    if (instance.params.scrollbar) instance.params.scrollbar.dragSize = thumbSize()
    instance.update()
  }

  new Swiper(root, {
    modules: [Navigation, Scrollbar],
    slidesPerView: 1,
    spaceBetween: gap(),
    // 送りはVOICEと同じくカード1枚ずつ（slidesPerGroupは既定の1のまま）
    breakpoints: {
      1025: {
        slidesPerView: 2,
      },
    },
    navigation: {
      prevEl: prev,
      nextEl: next,
    },
    scrollbar: {
      el: scrollbar,
      // つまみはHTMLに置いてあるのでSwiperは生成せず、これを掴む
      dragClass: "works__barThumb",
      dragSize: thumbSize(),
      draggable: true,
    },
    on: {
      // 余白もつまみの幅もvw指定なのでリサイズのたびに変わる。ブレークポイント跨ぎでは
      // breakpointsに書いた値で上書きされるため、どちらのタイミングでも入れ直す
      resize: (instance) => {
        applyCssSizes(instance)
      },
      breakpoint: (instance) => {
        applyCssSizes(instance)
      },
    },
  })
}

document.querySelectorAll<HTMLElement>("[data-works]").forEach(initWorks)
